import { render } from "./ClientDashboard.vue?vue&type=template&id=7d126c3d"
import script from "./ClientDashboard.vue?vue&type=script&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&lang=js"

import "./ClientDashboard.vue?vue&type=style&index=0&id=7d126c3d&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__